// Friend Pay Constants
// Centralized constants for the friend pay feature

// Icon dimensions
exports.FRIEND_PAY_ICON_SIZES = {
  LARGE: 56,
  MEDIUM: 28,
  SMALL: 20,
  EXTRA_LARGE: 24
};

// CSS class names
exports.FRIEND_PAY_CLASSES = {
  SHEET_ACTIVE: 'ottu__sdk-active',
  BORDER_GREEN: 'ottu__sdk-border-green',
  HIDDEN: 'ottu__sdk-hidden'
};

// DOM selectors
exports.FRIEND_PAY_SELECTORS = {
  MAIN_SHEET: '#ottu__sdk-friend-pay-sheet',
  SEND_SHEET: '#ottu__sdk-friend-pay-send-sheet',
  CLOSE_BTN: '.ottu__sdk-friend-pay-sheet-close',
  OVERLAY: '.ottu__sdk-friend-pay-sheet-overlay',
  CONTENT: '.ottu__sdk-friend-pay-sheet-content',
  SEND_TO_FRIEND_BTN: '.ottu__sdk-friend-pay-send-btn',
  CHANGE_PAYMENT_BTN: '.ottu__sdk-friend-pay-change-btn',
  UPDATE_BTN: '#ottu__sdk-friend-pay-update-btn',
  COUNTDOWN: '.ottu__sdk-friend-pay-countdown',
  TEXTAREA: '#ottu__sdk-friend-pay-message-textarea',
  CHAR_COUNT: '#ottu__sdk-friend-pay-char-count',
  SHARE_BUTTONS: '.ottu__sdk-friend-pay-share-btn'
};

// Timing constants
exports.FRIEND_PAY_TIMING = {
  ANIMATION_DELAY_MS: 100,
  TIMER_INTERVAL_MS: 1000,
  MAX_TEXTAREA_LENGTH: 200
};

// Share platform configurations
exports.SHARE_PLATFORMS = [
  { type: 'whatsapp', label: 'WhatsApp', svgKey: 'whatsapp', bgClass: 'ottu__sdk-whatsapp-bg' },
  { type: 'messenger', label: 'Messenger', svgKey: 'messenger', bgClass: 'ottu__sdk-messenger-bg' },
  { type: 'messages', label: 'Messages', svgKey: 'messages', bgClass: 'ottu__sdk-messages-bg' },
  { type: 'email', label: 'Email', svgKey: 'email', bgClass: 'ottu__sdk-email-bg' },
  { type: 'facebook', label: 'Facebook', svgKey: 'facebook', bgClass: 'ottu__sdk-facebook-bg' },
  { type: 'share', label: 'Share', svgKey: 'share', bgClass: 'ottu__sdk-share-bg' },
  { type: 'copy', label: 'Copy link', svgKey: 'copyLink', bgClass: 'ottu__sdk-copy-bg' }
];

// Default messages
exports.FRIEND_PAY_DEFAULTS = {
  SHARE_MESSAGE_EN: 'Please help me pay for my order!',
  SHARE_MESSAGE_AR: 'من فضلك ساعدني في دفع قيمة طلبي!',
  FALLBACK_CURRENCY: 'USD',
  FALLBACK_AMOUNT: '0.00'
};

// Month names for date formatting
exports.MONTH_NAMES = {
  en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  ar: ['يناير', 'فبراير', 'مارس', 'ابريل', 'مايو', 'يونيو', 'يوليو', 'اغسطس', 'سبتمبر', 'اكتوبر', 'نوفمبر', 'ديسمبر']
};

// SVG icon paths
exports.FRIEND_PAY_SVG = {
  clock: process.env.SERVER_URL + '/v3/img/friend-pay-clock.svg',
  checkCircle: process.env.SERVER_URL + '/v3/img/friend-pay-check-circle.svg',
  mail: process.env.SERVER_URL + '/v3/img/friend-pay-mail.svg',
  arrowRight: process.env.SERVER_URL + '/v3/img/friend-pay-arrow-right.svg',
  close: process.env.SERVER_URL + '/v3/img/friend-pay-close.svg',
  update: process.env.SERVER_URL + '/v3/img/friend-pay-update.svg',
  whatsapp: process.env.SERVER_URL + '/v3/img/friend-pay-whatsapp-icon.svg',
  messenger: process.env.SERVER_URL + '/v3/img/friend-pay-messenger-icon.svg',
  messages: process.env.SERVER_URL + '/v3/img/friend-pay-messages-icon.svg',
  email: process.env.SERVER_URL + '/v3/img/friend-pay-email-icon.svg',
  facebook: process.env.SERVER_URL + '/v3/img/friend-pay-facebook-icon.svg',
  share: process.env.SERVER_URL + '/v3/img/friend-pay-share-icon.svg',
  copyLink: process.env.SERVER_URL + '/v3/img/friend-pay-copy-link-icon.svg',
};

// Share URL templates
exports.FRIEND_PAY_SHARE_URLS = {
  WHATSAPP: 'https://wa.me/?text=',
  MESSENGER: 'fb-messenger://share?link=',
  FACEBOOK: 'https://www.facebook.com/sharer/sharer.php?u=',
  SMS: 'sms:?&body=',
  EMAIL_MAILTO: 'mailto:?subject=',
  EMAIL_BODY: '&body='
};

// Share-related messages
exports.FRIEND_PAY_MESSAGES = {
  LINK_COPIED: 'Link copied to clipboard!',
  COPY_FAILED: 'Failed to copy link. Please copy manually: ',
  PAYMENT_REQUEST_TITLE: 'Payment Request',
  EMAIL_SUBJECT: 'Please help me pay for my order'
};
